import {MyTopPerformingGamesDataItem} from '../../reducers/fortnite-game/myTopPerformingGames.reducer';
import {CodeNamesMap} from '../../reducers/games.reducer';
import {GameDataItem} from '../../types';

export interface MappedGameDataItem extends GameDataItem {
    loading?: boolean;
}

export const getRank = (maxValue: number, value: number): number =>
    maxValue ? Math.trunc(((value || 0) * 100) / maxValue) : 0;

export const getMappedGame = (
    codeNamesMap: CodeNamesMap,
    game: MyTopPerformingGamesDataItem,
    gamesLoading?: boolean
): MyTopPerformingGamesDataItem => {
    const codeName = codeNamesMap[game.creativeIslandCode]
        ? String(codeNamesMap[game.creativeIslandCode])
        : '';

    return {
        ...game,
        value: codeName,
        loading: game.loading || gamesLoading
    };
};
